var myLazyLoad = new LazyLoad({
  elements_selector: ".lazy",
});

$(function () {
  var mobile = false;
  var tablet = false;
  var desktop = false;

  // Reusable functions
  function showOnHover(source, target) {
    $(source)
      .on("mouseenter", function () {
        $(target).addClass("show");
      })
      .on("mouseleave", function () {
        $(target).removeClass("show");
      });
  }
  // end reusable functions

  /* Detections */
  var root = document.getElementsByTagName("html")[0];
  if (!document.createElement("svg").getAttributeNS) {
    root.setAttribute("class", "no-svg");
    return;
  }
  /* IE 10 Detection due to checkbox issues */
  if (Function("/*@cc_on return document.documentMode===10@*/")()) {
    document.documentElement.className += " ie10";
  }
  /* End Detections */

  /* polyfill fix for chair animation */
  if (!window.location.origin) {
    window.location.origin =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "");
  }

  function checkWidth() {
    var viewportWidth = window.viewportSize.getWidth();
    if (viewportWidth <= 768) {
      if (!mobile) {
        $("body").addClass("mobile").removeClass("desktop");
        $("body.pgproduct .cart-handler h1").insertAfter("ul.breadcrumb");
        $("body.pgproduct ul.slides li a").contents().unwrap();
      }
      mobile = true;
      desktop = false;
      tablet = false;
    } else if (viewportWidth >= 769 && viewportWidth <= 960) {
      if (!tablet) {
        $("body").removeClass("mobile dekstop").addClass("tablet");
      }
      mobile = false;
      desktop = false;
      tablet = true;
    } else {
      if (!desktop) {
        $("body").removeClass("mobile").addClass("desktop");
      }
      mobile = false;
      desktop = true;
      tablet = false;
    }
  }
  checkWidth();
  $(window).on("resize", checkWidth);

  /* Menus*/
  function toggleTopNav() {
    $("#btn-main-nav, .btn-main-nav").toggleClass("activated inactive");
    $("ul.top-nav").fadeToggle(0);
  }
  function toggleSearch() {
    $("div.search").toggleClass("search-open search-closed");
  }
  $("#btn-search").on("click", function () {
    if ($("ul.top-nav").not("body.desktop ul.top-nav").is(":visible")) {
      toggleTopNav();
    }
    $(this).toggleClass("search-inactive search-active");
    $(".search input[type=search]").trigger("focus");
    toggleSearch();
  });
  $("#btn-main-nav, .btn-main-nav").on("click", function () {
    if ($("div.search").hasClass("search-open")) {
      $("#btn-search").toggleClass("search-inactive search-active");
      toggleSearch();
    }
    toggleTopNav();
  });

  /*Flexslider */
  $(function () {
    $(".item-image, .slider").flexslider({
      animation: "slide",
      animationLoop: false,
      useCSS: false,
    });
  });

  //Product Page Item description collapse and tabs
  $("#tabs > div").hide();
  $("#tabs > div:first").show();
  $("#tabs > ul.tab-links li:first").addClass("active");
  $("#tabs > ul.tab-links li a").on("click", function () {
    $("#tabs > ul.tab-links li").attr("class", "");
    $(this).parent().attr("class", "active");
    var currentTab = $(this).attr("href");
    $("#tabs > div").hide();
    $(currentTab).show();
    return false;
  });

  /* Slide Up Elements */
  $(".anim").addClass("hidden").viewportChecker({
    classToAdd: "visible animation fadeInUp",
    offset: 40,
  });

  /* Fade In Elements */
  $(".anim-fade, .mobile-cta span").addClass("hidden").viewportChecker({
    classToAdd: "visible animation fadeIn",
    offset: 40,
  });

  /* Lazy Load Background Images*/
  $(".sites-wrapper").viewportChecker({
    classToAdd: "visible",
    offset: -250,
  });

  var vieWidth = window.viewportSize.getWidth();

  /* Promo Headers - */
  (function ($) {
    $.fn.flowtype = function (options) {
      var settings = $.extend(
          {
            maximum: 9999,
            minimum: 1,
            maxFont: 9999,
            minFont: 1,
            fontRatio: 35,
          },
          options
        ),
        changes = function (el) {
          var $el = $(el),
            elw = $el.width(),
            width =
              elw > settings.maximum
                ? settings.maximum
                : elw < settings.minimum
                ? settings.minimum
                : elw,
            fontBase = width / settings.fontRatio,
            fontSize =
              fontBase > settings.maxFont
                ? settings.maxFont
                : fontBase < settings.minFont
                ? settings.minFont
                : fontBase;
          $el.css("font-size", fontSize + "px");
        };

      return this.each(function () {
        var that = this;
        $(window).on("resize", function () {
          changes(that);
        });
        changes(this);
      });
    };
  })(jQuery);
  $("#hdr-banner p, .sweeps_banner").flowtype({
    minimum: 420,
    maximum: 1200,
    minFont: 17,
    maxFont: 45,
    fontRatio: 35,
  });
  $(".promo-wrapper .promo-inner").flowtype({
    minimum: 420,
    maximum: 1200,
    minFont: 16,
    //maxFont   : 45,
    fontRatio: 35,
  });

  /*Hover Intent*/
  $(".shop-cart").hoverIntent({
    timeout: 50,
    interval: 10,
    over: function() {
      this.className.replace("hover", "");
      this.className = this.className + " hover";
    },
    out: function() {
      this.className = this.className.replace("hover", "");
    },
  });

  // initialize mapify
  $("img[usemap]").mapify();

  // homepage image map effect on hover (source, target)
  showOnHover("#im-pillows", ".item-1 span");
  showOnHover("#im-pad", ".item-2 span");
  showOnHover("#im-blanket", ".item-3 span");

  // Chair Animation
  var chairTimeline = gsap.timeline();
  var chairDiv = document.getElementById("chair-div");
  var chairDivImg = document.getElementById("chair-img");
  var tlArr = ["one", "two", "three", "four", "five", "six", "seven", "eight"];
  var chairImages = [];
  var preloadImages = [];
  var preloaded = false;
  var dur;
  function preloadChairImages() {
    // prevents script from running twice
    if (chairImages.length < tlArr.length) {
      //create array with chair images & preload them
      for (var i = 0; i < tlArr.length; i++) {
        var ext = i === 7 ? ".png" : ".jpg";
        chairImages.push("images/homepage/chair/chair_" + tlArr[i] + ext);
        preloadImages[i] = new Image();
        preloadImages[i].src = window.location.origin + "/" + chairImages[i];
        preloadImages.push(preloadImages[i]);
      }
      preloadImages[tlArr.length].onload = function () {
        preloaded = true;
        chairDiv.className = chairDiv.className.replace(/\bloading\b/g, "");
      };
    }
  }
  function chairDivInViewportHandler() {
    if (preloaded === true) {
      chairAnimation();
    } else {
      preloadChairImages();
      preloadImages[tlArr.length].onload = function () {
        chairDiv.className = chairDiv.className.replace(/\bloading\b/g, "");
        chairAnimation();
      };
    }
  }
  function chairAnimation() {
    for (var i = 0; i < tlArr.length; i++) {
      if (tlArr[i] === "six") {
        dur = 0.5;
      } else {
        dur = 0.1;
      }
      chairTimeline.to(chairDivImg, {
        duration: dur,
        attr: { src: chairImages[i] },
      });
    }
    dur = 0.5;
    chairTimeline
      .to($("#chair-bg"), { duration: dur, opacity: 1 })
      .to($(".chair-text-top .human-scale, .chair-text-top .office-chair"), {
        duration: dur,
        opacity: 1,
        y: -10,
      })
      .to($(".chair-text-top p"), { duration: dur, opacity: 1, y: -10 })
      .to($(".chair-text-top .btn-main"), {
        duration: dur,
        opacity: 1,
        y: -10,
      });
  }
  function chairIconsAnimation() {
    chairTimeline.to($(".chair-text-bottom"), 0.5, { opacity: 1, y: -10 });
  }
  if (vieWidth > 768) {
    $(".row-linens").viewportChecker({
      offset: 300,
      callbackFunction: preloadChairImages,
    });
    $("#chair-div").viewportChecker({
      offset: 300,
      callbackFunction: chairDivInViewportHandler,
    });
    $(".chair-text-bottom").viewportChecker({
      offset: 100,
      callbackFunction: chairIconsAnimation,
    });
  }
  // end chair animation

  // HP Bedding Positioning
  function hpBedHeightHandler() {
    var beddingHeight = $(".row-bedding").height() / 12;
    $(".row-bedding .img-wrap").css(
      "margin-top",
      "-" + (beddingHeight + beddingHeight / 11) + "px"
    );
    $(".row-linens").css("top", "-" + beddingHeight + "px");
  }
  //hpBedHeightHandler();
  $(".mapify-img").onload = hpBedHeightHandler();
  $(window).on("resize", hpBedHeightHandler);
}); /* end document.ready */

/* Slide In Animations Viewport Check */
(function ($) {
  $.fn.viewportChecker = function (useroptions) {
    var options = {
      classToAdd: "visible",
      offset: 100,
      callbackFunction: function (elem) {},
    };
    $.extend(options, useroptions);
    var $elem = this,
      windowHeight = $(window).height();

    this.checkElements = function () {
      // Set some vars to check with
      var viewportTop = Math.max(
          $("html").scrollTop(),
          $("body").scrollTop(),
          $(window).scrollTop()
        ),
        viewportBottom = viewportTop + windowHeight;

      $elem.each(function () {
        var $obj = $(this);
        if ($obj.hasClass(options.classToAdd)) {
          return;
        }
        var elemTop = Math.round($obj.offset().top) + options.offset,
          elemBottom = elemTop + $obj.height();
        if (elemTop < viewportBottom && elemBottom > viewportTop) {
          $obj.addClass(options.classToAdd);
          options.callbackFunction($obj);
        }
      });
    };
    $(window).on("scroll", this.checkElements);
    this.checkElements();
    $(window).on("resize", function (e) {
      windowHeight = e.currentTarget.innerHeight;
    });
  };
})(jQuery);
